import { render, staticRenderFns } from "./SummaryBox.vue?vue&type=template&id=1a37116e&scoped=true&"
import script from "./SummaryBox.vue?vue&type=script&lang=js&"
export * from "./SummaryBox.vue?vue&type=script&lang=js&"
import style0 from "./SummaryBox.vue?vue&type=style&index=0&id=1a37116e&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a37116e",
  null
  
)

export default component.exports